function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var success = function success(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "#e2edf1"
    }), _jsx("path", {
      d: "m14.875 8-4.132 5.57a1.062 1.062 0 0 1-1.609.115L7 11.527",
      stroke: "#059669",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
success.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { success };
var info = function info(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "currentColor"
    }), _jsx("path", {
      d: "M11.091 8.488C10.423 8.488 10 7.97 10 7.215 10 6.473 10.457 6 11.091 6c.647 0 1.091.473 1.091 1.216 0 .756-.433 1.27-1.09 1.27v.002Zm-.88.905h1.773v4.458c0 .325.222.473.516.473v1.527l-.716.149c-.892 0-1.573-.554-1.573-1.581V9.392Z",
      fill: "#0059B8"
    })]
  }));
};
info.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { info };
var warning = function warning(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "currentColor"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.203 13.595a1.203 1.203 0 1 0 0 2.405 1.203 1.203 0 0 0 0-2.405Z",
      fill: "#D97706"
    }), _jsx("path", {
      d: "M11.203 11.36V6",
      stroke: "#D97706",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    })]
  }));
};
warning.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { warning };
var warningRed = function warningRed(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "currentColor"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.203 13.595a1.203 1.203 0 1 0 0 2.405 1.203 1.203 0 0 0 0-2.405Z",
      fill: "#DC2626"
    }), _jsx("path", {
      d: "M11.203 11.36V6",
      stroke: "#DC2626",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    })]
  }));
};
warningRed.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { warningRed };
var error = function error(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("circle", {
      cx: "11",
      cy: "11",
      r: "11",
      fill: "currentColor"
    }), _jsx("path", {
      stroke: "#DC2626",
      strokeWidth: "2",
      strokeLinecap: "round",
      d: "m7.566 7.849 7.071 7.071M14.637 8.051l-7.071 7.071"
    })]
  }));
};
error.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { error };
var sortOrder = function sortOrder(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "m1.057 6 4.9-4.9a.342.342 0 0 1 .484 0l4.9 4.9",
      stroke: "#9CA3AF",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "m11.284 12-4.9 4.9a.342.342 0 0 1-.484 0L1 12",
      stroke: "#191C2C",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
sortOrder.defaultProps = {
  viewBox: "0 0 13 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { sortOrder };
var passiveSort = function passiveSort(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "m1.057 6 4.9-4.9a.342.342 0 0 1 .484 0l4.9 4.9M11.284 12l-4.9 4.9a.342.342 0 0 1-.484 0L1 12",
      stroke: "#9CA3AF",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};
passiveSort.defaultProps = {
  viewBox: "0 0 13 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { passiveSort };
var exclamation = function exclamation(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
      fill: "#DC2626"
    }), _jsx("path", {
      d: "M8 4.5v5M.741 12.776 6.97 1.208a1.17 1.17 0 0 1 2.06 0l6.229 11.568a1.17 1.17 0 0 1-1.03 1.724H1.771a1.17 1.17 0 0 1-1.03-1.724v0Z",
      stroke: "#DC2626",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
exclamation.defaultProps = {
  width: "16",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { exclamation };
var address = function address(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M1 11.465 9.986 1.462c.133-.147.29-.264.464-.343a1.304 1.304 0 0 1 1.094.004c.173.08.33.198.463.346L21 11.465",
      stroke: "#191C2C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M18.143 8.29V21H3.857V8.285",
      stroke: "#191C2C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M13.857 21v-4.767c0-.843-.3-1.652-.836-2.248-.536-.595-1.263-.93-2.02-.93-.759 0-1.485.335-2.021.93a3.368 3.368 0 0 0-.837 2.248V21",
      stroke: "#191C2C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
address.defaultProps = {
  width: "22",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { address };
var calendar = function calendar(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M19.666 3.668H2.333C1.597 3.668 1 4.265 1 5.001v14.667C1 20.404 1.597 21 2.333 21h17.333c.737 0 1.334-.597 1.334-1.333V5c0-.736-.597-1.333-1.334-1.333ZM1 9h20M6.333 5.667V1M15.667 5.667V1",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "calendar-path"
    })
  }));
};
calendar.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { calendar };
var email = function email(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M21 4v12c0 1.657-1.28 3-2.857 3H3.857C2.28 19 1 17.658 1 16V4",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      clipRule: "evenodd",
      d: "M21 4c0-1.657-1.28-3-2.857-3H3.857C2.28 1 1 2.343 1 4l8.486 5.546a2.742 2.742 0 0 0 3.028 0L21 4Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
email.defaultProps = {
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { email };
var google = function google(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.04 12.261c0-.815-.073-1.6-.21-2.352H12v4.449h6.19a5.29 5.29 0 0 1-2.296 3.47v2.886h3.717c2.174-2.002 3.429-4.95 3.429-8.452Z",
      fill: "#4285F4"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 23.5c3.104 0 5.708-1.03 7.61-2.787l-3.716-2.885c-1.03.69-2.347 1.098-3.895 1.098-2.995 0-5.53-2.023-6.434-4.741H1.723v2.98A11.496 11.496 0 0 0 12 23.5Z",
      fill: "#34A853"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.565 14.185a6.913 6.913 0 0 1-.36-2.184c0-.758.13-1.495.36-2.186v-2.98H1.723A11.495 11.495 0 0 0 .5 12.002c0 1.855.444 3.612 1.223 5.164l3.842-2.98Z",
      fill: "#FBBC05"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 5.074c1.688 0 3.204.58 4.396 1.72l3.298-3.299C17.702 1.64 15.099.5 12 .5A11.496 11.496 0 0 0 1.723 6.835l3.842 2.98c.904-2.718 3.44-4.741 6.434-4.741Z",
      fill: "#EA4335"
    })]
  }));
};
google.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { google };
var order = function order(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M19 19.667c0 .353-.136.692-.377.942-.24.25-.568.391-.909.391H2.286c-.341 0-.668-.14-.91-.39A1.359 1.359 0 0 1 1 19.666V2.333c0-.353.135-.692.377-.942.24-.25.568-.391.909-.391H15.18c.336 0 .658.136.899.379l2.532 2.562a1.376 1.376 0 0 1 .388.955v14.77ZM4.895 7.668h10.286M4.895 11.666h10.286M4.895 15.668h5.143",
      stroke: "#191C2C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};
order.defaultProps = {
  width: "20",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { order };
var user = function user(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M5.824 3.297c.75.75 1.65 1.346 2.645 1.753a8.308 8.308 0 0 0 3.147.617 8.32 8.32 0 0 0 3.184-.631",
      stroke: "#191C2C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M10 10.333c2.676 0 4.846-2.09 4.846-4.666C14.846 3.089 12.676 1 10 1S5.154 3.09 5.154 5.667s2.17 4.666 4.846 4.666ZM1 20.999c0-2.299.948-4.503 2.636-6.129 1.688-1.625 3.977-2.538 6.364-2.538s4.676.913 6.364 2.538C18.052 16.496 19 18.7 19 21",
      stroke: "#191C2C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
user.defaultProps = {
  width: "20",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { user };
var checkmark = function checkmark(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M8.875 1.578 4.743 7.043a1.07 1.07 0 0 1-1.61.113L1 5.04",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};
checkmark.defaultProps = {
  viewBox: "0 0 10 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { checkmark };
var crossmark = function crossmark(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      stroke: "#DC2626",
      strokeWidth: "2",
      strokeLinecap: "round",
      d: "m5.566 4.849 7.071 7.071M12.637 5.051l-7.071 7.071"
    })
  }));
};
crossmark.defaultProps = {
  width: "18",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { crossmark };
var userOutlined = function userOutlined(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M11 13.667a4.667 4.667 0 1 0 0-9.333 4.667 4.667 0 0 0 0 9.333ZM17.145 18.89a8.665 8.665 0 0 0-12.29 0",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
userOutlined.defaultProps = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { userOutlined };
var intercom = function intercom(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("circle", {
      cx: "30",
      cy: "30",
      r: "30",
      fill: "currentColor"
    }), _jsx("path", {
      d: "M44 46s-4.714-1.855-8.527-3.34H19.437C17.54 42.66 16 41.026 16 39.013V17.644C16 15.633 17.54 14 19.437 14h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H44V46Zm-4.139-11.982a.88.88 0 0 0-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 0 0-1.29.107 1.01 1.01 0 0 0 .099 1.372c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15.187-.172.3-.41.317-.664a1.01 1.01 0 0 0-.218-.707Z",
      fill: "#fff"
    })]
  }));
};
intercom.defaultProps = {
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { intercom };
var search = function search(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M12.7 11.23a6.777 6.777 0 0 0 1.4-4.174C14.1 3.18 11 0 7.1 0S0 3.18 0 7.056s3.2 7.056 7.1 7.056c1.6 0 3.1-.497 4.2-1.392l3 2.982c.2.199.5.298.7.298.2 0 .5-.1.7-.298.4-.398.4-.994 0-1.391l-3-3.081Zm-5.6.795c-2.8 0-5.1-2.186-5.1-4.97 0-2.782 2.3-5.067 5.1-5.067s5.1 2.285 5.1 5.068c0 2.783-2.3 4.969-5.1 4.969Z",
      fill: "currentColor"
    })
  }));
};
search.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { search };
var back = function back(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M3.968 8.748.276 5.126c-.01-.005-.015-.015-.02-.02a.848.848 0 0 1-.246-.477c0-.014-.005-.03-.005-.044C0 4.555 0 4.526 0 4.497l.005-.084c0-.015.005-.03.005-.044a.832.832 0 0 1 .246-.477l.02-.02L3.968.251A.885.885 0 0 1 4.59 0c.225 0 .45.084.62.25.342.335.342.88 0 1.22L2.992 3.645h8.132c.481 0 .877.389.877.86a.87.87 0 0 1-.255.61.875.875 0 0 1-.622.25H2.991l2.22 2.177c.34.335.34.88 0 1.22a.91.91 0 0 1-1.243-.015Z",
      fill: "#000"
    })
  }));
};
back.defaultProps = {
  viewBox: "0 0 12 9",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
export { back };
var daslabLogo = function daslabLogo(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsxs("g", {
      clipPath: "url(#a)",
      children: [_jsx("path", {
        d: "M38.572 5.943c-.607 0-1.189.08-1.77.188-1.506.321-2.562 1.606-2.694 3.132-.133 1.312.37 2.731 1.585 3.347 1.162.75 2.589 1.151 3.778 1.847.502.295.872.75.872 1.366 0 .616-.37 1.178-.952 1.365-.343.107-.713.161-1.11.161a3.658 3.658 0 0 1-1.61-.375 8.726 8.726 0 0 1-1.163-.857.827.827 0 0 0-.502-.187.745.745 0 0 0-.581.268l-.529.616c-.264.32-.264.776.027 1.07.264.295.528.563.845.804.608.482 1.321.803 2.034 1.044.555.16 1.11.268 1.691.268.82 0 1.612-.161 2.351-.51.952-.427 1.744-1.124 2.193-2.087.555-1.178.317-2.544-.343-3.615-.846-1.392-2.404-1.767-3.805-2.356-.502-.214-1.189-.509-1.585-.937-.581-.643-.343-1.74.45-2.035a2.47 2.47 0 0 1 .871-.134c.397 0 .82.08 1.19.188.448.134.87.428 1.188.669a.745.745 0 0 0 1.03-.107l.397-.428a.809.809 0 0 0-.053-1.125l-.37-.348c-1.427-1.125-2.59-1.232-3.435-1.232ZM23.725 17.108c-2.246 0-4.043-1.847-4.043-4.096 0-2.25 1.824-4.097 4.043-4.097 2.219 0 4.042 1.848 4.042 4.097 0 2.249-1.797 4.096-4.042 4.096Zm0-11.165c-3.831 0-6.949 3.16-6.949 7.042 0 3.802 2.986 7.041 6.684 7.041h.265c1.585-.053 2.932-.803 4.068-1.847v.964c0 .294.238.508.502.508h1.876c.29 0 .502-.24.502-.508V12.958c-.026-3.855-3.117-7.015-6.948-7.015ZM6.948 17.08c-2.245 0-4.042-1.846-4.042-4.095 0-2.25 1.823-4.097 4.042-4.097 2.22 0 4.069 1.82 4.069 4.07 0 2.249-1.823 4.123-4.069 4.123ZM13.395.054h-1.876a.505.505 0 0 0-.502.508v7.23C9.88 6.745 8.533 5.996 6.948 5.942h-.264C2.985 5.943 0 9.183 0 12.985c0 3.882 3.118 7.041 6.948 7.041 3.831 0 6.949-3.133 6.949-7.015V.588c0-.294-.238-.535-.502-.535ZM90.328 17.108c-2.246 0-4.042-1.847-4.042-4.096 0-2.25 1.823-4.097 4.042-4.097 2.246 0 4.042 1.848 4.042 4.097 0 2.249-1.796 4.096-4.042 4.096Zm0-11.165c-3.83 0-6.948 3.16-6.948 7.042 0 3.802 2.985 7.041 6.684 7.041h.264c1.585-.053 2.933-.803 4.069-1.847v.964c0 .294.238.508.502.508h1.876c.29 0 .501-.24.501-.508V12.958c-.026-3.882-3.117-7.015-6.948-7.015ZM107.052 17.08c-2.246 0-4.042-1.846-4.042-4.095 0-2.25 1.823-4.097 4.042-4.097 2.245 0 4.042 1.848 4.042 4.097 0 2.248-1.823 4.096-4.042 4.096ZM102.481.054h-1.876a.505.505 0 0 0-.501.508v12.423c0 3.883 3.117 7.015 6.948 7.015 3.831 0 6.948-3.16 6.948-7.041 0-3.802-2.985-7.042-6.684-7.042h-.264c-1.585.054-2.933.803-4.069 1.848V.534a.5.5 0 0 0-.502-.481ZM81.16 16.733a.42.42 0 0 1 .423.428v2.062c0 .16-.158.455-.422.455-.899 0-2.933-.027-3.937-.482-2.246-1.017-3.355-2.677-3.593-5.167-.026-.429-.026-.857-.026-1.286V.481a.42.42 0 0 1 .422-.428h2.034a.42.42 0 0 1 .423.428v13.012c0 1.633 1.057 2.972 2.616 3.186.634.08 1.294.027 1.928.054h.132Z",
        fill: "#191C2D"
      }), _jsx("path", {
        d: "M66.709 15.716c-.846-1.927-2.008-1.74-2.933-3.186 0 .027 0 .027-.026.027v-.027c.158-.455.317-.937.423-1.419.343-1.5.422-3.106-.159-4.525-.819-2.008-2.536-3.534-4.2-4.846C58.413.643 56.483 0 54.608 0c-.423 0-.846.027-1.268.107-1.004.16-1.903.696-2.669 1.339-1.77 1.526-2.166 3.721-1.162 5.836.581 1.205 1.717 2.035 2.008 3.374.502 2.41-.608 5.14.766 7.363C53.103 19.384 54.45 20 55.85 20c.846 0 1.718-.241 2.537-.67.053-.026.105-.053.132-.08.211.08.343.107.343.107 1.216.429 2.563.59 3.752.616h.106c1.453 0 2.959-.535 3.698-1.874.423-.696.608-1.606.29-2.383Zm-10.832 3.24c-1.136 0-2.087-.536-2.668-1.473-.66-1.07-.582-2.41-.502-3.802.052-1.044.105-2.141-.106-3.212-.211-1.018-.793-1.794-1.321-2.464-.29-.401-.581-.776-.766-1.15-.82-1.688-.502-3.348.898-4.552.713-.616 1.453-.991 2.166-1.098.344-.054.714-.08 1.11-.08 1.638 0 3.329.562 4.57 1.526 1.586 1.231 3.17 2.65 3.858 4.39.528 1.312.343 2.839.105 3.883a.384.384 0 0 1-.052.16c-.08-.294-.159-.642-.238-1.017-.37-1.928-1.981-3.08-3.54-3.08-.581 0-1.136.162-1.638.483-1.903 1.258-2.404 4.177-2.563 5.997-.106 1.178.053 2.33.555 3.4.396.83 1.057 1.42 1.664 1.821-.555.16-1.056.268-1.532.268Zm2.563-.884c-.608-.294-1.427-.83-1.823-1.686-.397-.83-.555-1.821-.45-2.838.265-2.705.952-4.472 2.088-5.221a1.91 1.91 0 0 1 1.083-.322c1.03 0 2.22.777 2.51 2.223.185.963.449 1.74.766 2.382-.793 1.848-2.378 4.23-4.174 5.462Zm7.08-.455c-.66 1.232-2.298 1.339-2.774 1.339h-.08c-1.109-.027-2.14-.16-3.037-.429 1.505-1.258 2.826-3.132 3.672-4.846.396.456.819.75 1.162.991.529.375.925.67 1.295 1.473.132.374.053.937-.238 1.472Z",
        fill: "#05C5D1"
      })]
    }), _jsx("defs", {
      children: _jsx("clipPath", {
        id: "a",
        children: _jsx("path", {
          fill: "#fff",
          d: "M0 0h114v20H0z"
        })
      })
    })]
  }));
};
daslabLogo.defaultProps = {
  width: "114",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { daslabLogo };
var menu = function menu(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("g", {
      fill: "#4A1EA6",
      children: _jsx("path", {
        d: "M1.2 9.2c-1.6 1.6-1.5 4.3.2 5.7.9.8 10 1.1 31.1.9 27.1-.3 29.9-.5 30.9-2.1.8-1.2.8-2.2 0-3.5-1-1.5-3.8-1.7-31-2-22.5-.2-30.3.1-31.2 1zM1.2 29.2c-1.6 1.6-1.5 4.3.2 5.7.9.8 10 1.1 31.1.9 27.1-.3 29.9-.5 30.9-2.1.8-1.2.8-2.2 0-3.5-1-1.5-3.8-1.7-31-2-22.5-.2-30.3.1-31.2 1zM1.2 49.2c-1.6 1.6-1.5 4.3.2 5.7.9.8 10 1.1 31.1.9 27.1-.3 29.9-.5 30.9-2.1.8-1.2.8-2.2 0-3.5-1-1.5-3.8-1.7-31-2-22.5-.2-30.3.1-31.2 1z"
      })
    })
  }));
};
menu.defaultProps = {
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "85.333",
  height: "85.333",
  viewBox: "0 0 64 64"
};
export { menu };
var close = function close(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M4.707 3.293 3.293 4.707 10.586 12l-7.293 7.293 1.414 1.414L12 13.414l7.293 7.293 1.414-1.414L13.414 12l7.293-7.293-1.414-1.414L12 10.586 4.707 3.293z",
      fill: "#4A1EA6"
    })
  }));
};
close.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "48",
  height: "48"
};
export { close };
var hyperLink = function hyperLink(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("path", {
      d: "M12.656 9.375h-.937a.469.469 0 0 0-.469.469v3.281H1.875V3.75h4.219a.469.469 0 0 0 .468-.469v-.937a.469.469 0 0 0-.468-.469H1.406A1.406 1.406 0 0 0 0 3.281v10.313A1.406 1.406 0 0 0 1.406 15H11.72a1.406 1.406 0 0 0 1.406-1.406v-3.75a.469.469 0 0 0-.469-.469ZM14.296 0h-3.75a.705.705 0 0 0-.497 1.201l1.047 1.047-7.14 7.138a.703.703 0 0 0 0 .996l.663.663a.703.703 0 0 0 .996 0l7.137-7.14L13.8 4.952c.44.44 1.201.132 1.201-.498V.703A.703.703 0 0 0 14.297 0Z",
      fill: "#059669"
    })
  }));
};
hyperLink.defaultProps = {
  width: "15",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { hyperLink };
var folder = function folder(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M20.177 7.667h18.49A.333.333 0 0 1 39 8v24a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V1.333A.333.333 0 0 1 1.333 1H14.48l3.125 5.21a3 3 0 0 0 2.573 1.457ZM14.667 1Z",
      stroke: "#222",
      strokeWidth: "2"
    }), _jsx("path", {
      d: "M19.625 27.751a.875.875 0 0 1 0-1.75M19.625 27.751a.875.875 0 0 0 0-1.75",
      fill: "#222"
    }), _jsx("path", {
      d: "M19.625 27.751a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75Z",
      stroke: "#000"
    }), _jsx("path", {
      d: "M19.623 22.75v-7 7Z",
      fill: "#222"
    }), _jsx("path", {
      d: "M19.623 22.75v-7",
      stroke: "#222",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
folder.defaultProps = {
  width: "40",
  height: "36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { folder };
var document = function document(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("path", {
      d: "M4.691 15.668h8.616M4.691 11.668h8.616M4.691 7.668h2.462M11.143 1.322A1 1 0 0 0 10.408 1H2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.667l-5.857-6.345Z",
      stroke: "#222",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M10.846 1v5.667a1 1 0 0 0 1 1H17",
      stroke: "#222",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
document.defaultProps = {
  width: "18",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { document };
var burger = function burger(props) {
  return _jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: _jsx("g", {
      opacity: ".8",
      stroke: "#fff",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: _jsx("path", {
        d: "M16 2H2M16 9H2M16 16H2"
      })
    })
  }));
};
burger.defaultProps = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { burger };
var dobfailure = function dobfailure(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("g", {
      filter: "url(#a)",
      children: _jsx("circle", {
        cx: "43.4",
        cy: "36",
        r: "36",
        fill: "#F5F5F4"
      })
    }), _jsxs("g", {
      filter: "url(#b)",
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.833 13.46H32.57a7 7 0 0 0-7 7v30.664a7 7 0 0 0 7 7h22.337a7 7 0 0 0 7-7V29.372L46.833 13.461Z",
        fill: "#fff"
      }), _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M47.398 13.459v9.9a6 6 0 0 0 6 6h6.893c.502 0 .99-.062 1.457-.178l-14.35-15.722Z",
        fill: "#BBC9CF"
      }), _jsx("path", {
        d: "M33.33 28.223h6.435M33.33 36.928h20.44M33.33 46.012h20.44",
        stroke: "#CEDFE6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      })]
    }), _jsx("circle", {
      cx: "62.06",
      cy: "55.488",
      r: "10.094",
      fill: "#F8F8F8",
      fillOpacity: ".53"
    }), _jsx("g", {
      filter: "url(#c)",
      stroke: "#1B4C5F",
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: _jsx("path", {
        d: "m77.693 70.965-8.627-8.627M61.877 65.213c5.559 0 10.065-4.506 10.065-10.064 0-5.559-4.506-10.065-10.065-10.065-5.558 0-10.065 4.506-10.065 10.065 0 5.558 4.507 10.064 10.065 10.064Z"
      })
    }), _jsxs("g", {
      filter: "url(#d)",
      children: [_jsx("circle", {
        cx: "10.43",
        cy: "25.235",
        r: "10.43",
        fill: "#F8E3E5"
      }), _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.617 27.691a1.14 1.14 0 1 0 0 2.281 1.14 1.14 0 0 0 0-2.28Z",
        fill: "#DC2626"
      }), _jsx("path", {
        d: "M10.617 25.575v-5.083",
        stroke: "#DC2626",
        strokeWidth: "2",
        strokeLinecap: "round"
      })]
    }), _jsxs("defs", {
      children: [_jsxs("filter", {
        id: "a",
        x: "7.4",
        y: "0",
        width: "74",
        height: "74",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "1",
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35387"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35387",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "b",
        x: "22.57",
        y: "13.459",
        width: "42.336",
        height: "50.666",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dy: "3"
        }), _jsx("feGaussianBlur", {
          stdDeviation: "1.5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35387"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35387",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "c",
        x: "38.813",
        y: "39.084",
        width: "45.881",
        height: "45.881",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "-3",
          dy: "4"
        }), _jsx("feGaussianBlur", {
          stdDeviation: "4"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0.652969 0 0 0 0 0.79141 0 0 0 0 0.829167 0 0 0 0.52 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35387"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35387",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "d",
        x: "0",
        y: "14.805",
        width: "22.859",
        height: "22.859",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "1",
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35387"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35387",
          result: "shape"
        })]
      })]
    })]
  }));
};
dobfailure.defaultProps = {
  width: "85",
  height: "85",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { dobfailure };
var question = function question(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("g", {
      filter: "url(#a)",
      children: _jsx("circle", {
        cx: "36.402",
        cy: "36",
        r: "36",
        fill: "#F5F5F4"
      })
    }), _jsx("circle", {
      cx: "55.066",
      cy: "55.488",
      r: "10.094",
      fill: "#F8F8F8",
      fillOpacity: ".53"
    }), _jsx("mask", {
      id: "b",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: "9",
      y: "6",
      width: "59",
      height: "59",
      children: _jsx("path", {
        d: "M9 6h58.999v58.999H9V6Z",
        fill: "#fff"
      })
    }), _jsx("g", {
      mask: "url(#b)",
      children: _jsx("path", {
        d: "M9 32.219C9 17.773 22.205 6.062 38.496 6.062c16.289 0 29.494 11.711 29.494 26.157 0 14.445-13.205 26.157-29.494 26.157-1.844 0-3.647-.151-5.398-.439-4.316.851-9.582 5.771-13.793 6.862-1.538.399-2.765-1.312-1.885-2.64 2.985-4.497 4.786-6.715 3.293-9.072C13.6 48.313 9 40.742 9 32.22Z",
        fill: "#354089"
      })
    }), _jsx("mask", {
      id: "c",
      style: {
        maskType: "luminance"
      },
      maskUnits: "userSpaceOnUse",
      x: "10",
      y: "9",
      width: "58",
      height: "56",
      children: _jsx("path", {
        d: "M10.836 9.422h57.16v55.574h-57.16V9.422Z",
        fill: "#fff"
      })
    }), _jsx("g", {
      mask: "url(#c)",
      children: _jsx("path", {
        d: "M53.276 9.582c1.431 2.83 2.217 5.915 2.217 9.143 0 13.752-14.259 24.902-31.847 24.902-4.516 0-8.812-.737-12.705-2.063 1.99 4.61 5.406 8.595 9.773 11.525 1.493 2.357-.308 4.574-3.293 9.072-.88 1.328.347 3.038 1.884 2.64 4.212-1.091 9.477-6.011 13.794-6.862 1.75.287 3.554.438 5.398.438 16.289 0 29.494-11.711 29.494-26.157 0-9.67-5.916-18.111-14.715-22.638Z",
        fill: "#142178"
      })
    }), _jsx("path", {
      d: "M42.041 45.972c0 1.221-.305 2.122-.915 2.705-.612.581-1.47.872-2.578.872-1.135 0-2.009-.29-2.62-.872-.61-.583-.915-1.483-.915-2.705 0-1.236.305-2.133.916-2.694.61-.56 1.484-.84 2.62-.84 1.178 0 2.054.28 2.63.84.574.561.862 1.458.862 2.694Zm6.219-18.145a5.19 5.19 0 0 1-.394 2.049 7.343 7.343 0 0 1-1.012 1.701c-.412.518-.87.992-1.373 1.423-.504.43-.994.826-1.47 1.185-.476.36-.917.693-1.32 1.002-.405.31-.707.6-.905.873-.086.115-.185.29-.3.528-.112.236-.169.506-.169.809 0 .774-.238 1.414-.714 1.917-.476.503-1.217.754-2.225.754-.61 0-1.112-.097-1.502-.292a2.785 2.785 0 0 1-.937-.72 2.54 2.54 0 0 1-.49-.928 3.369 3.369 0 0 1-.138-.905c0-.976.163-1.795.49-2.457a6.15 6.15 0 0 1 1.235-1.713c.497-.48 1.03-.9 1.597-1.26.568-.36 1.1-.733 1.598-1.12a5.739 5.739 0 0 0 1.235-1.304c.326-.481.49-1.081.49-1.8 0-.747-.124-1.335-.373-1.767-.249-.43-.553-.75-.916-.959a3.039 3.039 0 0 0-1.128-.387 7.977 7.977 0 0 0-.99-.076c-.71 0-1.278.105-1.705.312-.426.21-.749.471-.969.787-.22.317-.361.664-.425 1.045a6.56 6.56 0 0 0-.097 1.089c0 .56-.107 1.038-.32 1.432-.212.396-.478.715-.797.96a3.298 3.298 0 0 1-1.044.539 3.553 3.553 0 0 1-1.034.171c-.964 0-1.745-.268-2.341-.807-.597-.54-.895-1.233-.895-2.08 0-.373.042-.855.127-1.443.086-.589.25-1.214.49-1.875a9.415 9.415 0 0 1 1.022-1.983 7.263 7.263 0 0 1 1.726-1.788c.709-.532 1.576-.963 2.598-1.293 1.023-.331 2.243-.497 3.663-.497 1.604 0 3.014.22 4.227.657 1.214.44 2.226 1.05 3.036 1.833a7.609 7.609 0 0 1 1.832 2.801c.41 1.085.617 2.281.617 3.587Z",
      fill: "#fff"
    }), _jsx("defs", {
      children: _jsxs("filter", {
        id: "a",
        x: ".402",
        y: "0",
        width: "74",
        height: "74",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "1",
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_2735_17390"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_2735_17390",
          result: "shape"
        })]
      })
    })]
  }));
};
question.defaultProps = {
  width: "75",
  height: "74",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { question };
var emailsent = function emailsent(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("g", {
      filter: "url(#a)",
      children: _jsx("circle", {
        cx: "36",
        cy: "36",
        r: "36",
        fill: "#F5F5F4"
      })
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 34.377a5 5 0 0 1 1.715-3.769L31.17 19.752a7 7 0 0 1 9.199 0l11.916 10.387A5 5 0 0 1 54 33.908v11.224c0 5.977-2.083 5.973-4.694 5.97H21.695c-2.61.003-4.694.007-4.694-5.97V34.377Z",
      fill: "#FCA89C"
    }), _jsx("rect", {
      x: "22.291",
      y: "17",
      width: "26.454",
      height: "28.218",
      rx: "4",
      fill: "#fff"
    }), _jsx("g", {
      filter: "url(#b)",
      children: _jsx("path", {
        d: "M30 29.344a5.879 5.879 0 1 0 5.879-5.88A5.886 5.886 0 0 0 30 29.345Z",
        fill: "#E2EDF1"
      })
    }), _jsx("path", {
      d: "m34.207 29.107.888.946-.888-.946Zm0 0a.404.404 0 0 0-.294-.124.404.404 0 0 0-.29.13.46.46 0 0 0-.123.31.46.46 0 0 0 .117.313l1.251 1.333c.079.083.185.13.295.13.11 0 .217-.047.295-.13l-1.251-1.962Zm4.244-1.08a.56.56 0 0 0 .149-.383.56.56 0 0 0-.15-.383.505.505 0 0 0-.367-.162.504.504 0 0 0-.368.162l-2.552 2.72-.883-.942-.001-.002a.504.504 0 0 0-.366-.154.505.505 0 0 0-.364.161.56.56 0 0 0-.149.378.56.56 0 0 0 .143.38l.001.002 1.252 1.334a.504.504 0 0 0 .367.161c.14 0 .272-.059.368-.162l2.92-3.11Z",
      fill: "#1B4C5F",
      stroke: "#1B4C5F",
      strokeWidth: ".2"
    }), _jsx("g", {
      filter: "url(#c)",
      children: _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.004 33.828a5.113 5.113 0 0 0-.004.208v16.867a4.897 4.897 0 0 0 4.897 4.898h27.206A4.897 4.897 0 0 0 54 50.903v-16.74l-14.54 9.013a7 7 0 0 1-7.377 0l-15.079-9.348Z",
        fill: "#fff"
      })
    }), _jsx("g", {
      filter: "url(#d)",
      children: _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m18.199 53.95 12.794-7.931a9 9 0 0 1 9.484 0l12.435 7.708a4.888 4.888 0 0 1-3.847 1.867H21.86a4.885 4.885 0 0 1-3.661-1.644Z",
        fill: "#fff"
      })
    }), _jsxs("defs", {
      children: [_jsxs("filter", {
        id: "a",
        x: "0",
        y: "0",
        width: "74",
        height: "74",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "1",
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35125"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35125",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "b",
        x: "29",
        y: "23.465",
        width: "13.758",
        height: "13.758",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35125"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35125",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "c",
        x: "14",
        y: "29.828",
        width: "43",
        height: "27.973",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dy: "-1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: "1.5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0.843137 0 0 0 0 0.886275 0 0 0 0 0.929412 0 0 0 1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35125"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35125",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "d",
        x: "4.199",
        y: "34.668",
        width: "62.713",
        height: "38.926",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dy: "4"
        }), _jsx("feGaussianBlur", {
          stdDeviation: "7"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0.843137 0 0 0 0 0.886275 0 0 0 0 0.929412 0 0 0 1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_35125"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_35125",
          result: "shape"
        })]
      })]
    })]
  }));
};
emailsent.defaultProps = {
  width: "74",
  height: "74",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { emailsent };
var uploadfile = function uploadfile(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [_jsx("g", {
      filter: "url(#a)",
      children: _jsx("circle", {
        cx: "36",
        cy: "36",
        r: "36",
        fill: "#F5F5F4"
      })
    }), _jsxs("g", {
      filter: "url(#b)",
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.43 13.459H25.17a7 7 0 0 0-7 7v30.664a7 7 0 0 0 7 7h22.336a7 7 0 0 0 7-7v-21.75L39.43 13.459Z",
        fill: "#fff"
      }), _jsx("path", {
        opacity: ".5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39.994 13.459v9.9a6 6 0 0 0 6 6h6.892c.503 0 .99-.062 1.457-.179L39.994 13.46Z",
        fill: "#F85139"
      }), _jsx("path", {
        d: "M25.928 28.223h6.434M25.928 36.924h20.439M25.928 46.012h20.439",
        stroke: "#CEDFE6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      })]
    }), _jsx("g", {
      filter: "url(#c)",
      children: _jsx("circle", {
        cx: "59.636",
        cy: "57.194",
        r: "10.766",
        transform: "rotate(90 59.636 57.194)",
        fill: "#E2EDF1"
      })
    }), _jsx("path", {
      d: "M59.639 62.579v-9.42M63.674 55.175l-4.037-3.364-4.037 3.364",
      stroke: "#1B4C5F",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsxs("defs", {
      children: [_jsxs("filter", {
        id: "a",
        x: "0",
        y: "0",
        width: "74",
        height: "74",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "1",
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_31781"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_31781",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "b",
        x: "15.17",
        y: "13.459",
        width: "42.336",
        height: "50.664",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dy: "3"
        }), _jsx("feGaussianBlur", {
          stdDeviation: "1.5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_31781"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_31781",
          result: "shape"
        })]
      }), _jsxs("filter", {
        id: "c",
        x: "48.869",
        y: "46.428",
        width: "23.533",
        height: "23.533",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [_jsx("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), _jsx("feColorMatrix", {
          in: "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), _jsx("feOffset", {
          dx: "1",
          dy: "1"
        }), _jsx("feGaussianBlur", {
          stdDeviation: ".5"
        }), _jsx("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), _jsx("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }), _jsx("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1665_31781"
        }), _jsx("feBlend", {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1665_31781",
          result: "shape"
        })]
      })]
    })]
  }));
};
uploadfile.defaultProps = {
  width: "74",
  height: "74",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { uploadfile };
//# sourceMappingURL=index.js.map